export class ApproveInvoiceCompletionData {
    constructor(
        public readonly approved: boolean,
        public readonly explanation?: string,
    ) {}
}